import React, { useEffect, useState } from 'react';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './AdminNavbar.css'; // CSS específico para AdminNavbar

const AdminNavbar = ({ toggleMenu }) => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`admin-navbar ${isScrolled ? 'admin-navbar-scrolled' : ''}`}>
      <div className="menu-icon-container" onClick={toggleMenu}>
        <i className="fas fa-bars menu-icon"></i>
      </div>
      <div className="admin-title-container">
        <h1 className="admin-title">Bienvenido</h1>
      </div>
      <img src={`${process.env.PUBLIC_URL}/img/KIOSCO.png`} alt="Logo" className="admin-logo" />
    </nav>
  );
};

export default AdminNavbar;


